<div class="overlay" *ngIf="openSideMenu"></div>

<header class="flex items-center justify-between w-full h-[130px] px-10 bg-light-purple">
  <a class="logo no-underline flex items-center space-x-2" href="/home">
    <img
      class="w-[200px] lg:w-[150px] min-w-20"
      [src]="logoUrl"
      alt="Prism Logo"
    />
  </a>

  <div *ngIf="!isSiteOffline" style="display: contents;">
    <prism-navbar
      class="prism-navbar"
      [ngClass]="{ 'mb-[20px] pl-[200px]': isLoggedIn }"
      [openSideMenu]="openSideMenu"
      (toggleSideMenu)="click()"
      (openLoginModal)="toggleModal(HeaderModalType.Login)"
      (closeSideMenu)="openSideMenu = false">
    </prism-navbar>

    <div *ngIf="isLoggedIn" class="relative text-left hidden lg:inline-block">
      <button
        type="button"
        class="flex items-center"
        aria-haspopup="true"
        [attr.aria-expanded]="isDropdownOpen"
        aria-label="Open user menu"
        (click)="toggleDropdown()">
        <img [src]="iconImgUrl" alt="" class="mr-2" />
        <i class="uil uil-angle-down text-xl text-dark-purple" aria-hidden="true"></i>
      </button>

      <div
        *ngIf="isDropdownOpen"
        #dropdownMenu
        class="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white"
        role="menu">
        <div class="px-4 py-2 text-sm text-gray-500" role="none">
          {{ currentUser()?.fullName }}
        </div>

        <div class="px-4 py-2 italic text-sm text-gray-500" role="none">
          {{ currentUser()?.roleName }}
        </div>

        <div *ngIf="currentUser()?.districtIds" class="px-4 py-2" role="none">
          {{ currentUser()?.districtName }}
        </div>

        <hr role="separator" />

        <div class="font-bold text-dark-gray" role="none">
          <a
            href="/account-settings"
            class="no-underline block px-4 py-2 text-sm"
            role="menuitem">
            Account Settings
          </a>

          <hr role="separator" />

          <button
            type="button"
            class="block w-full text-left px-4 py-2 text-sm"
            role="menuitem"
            (click)="logout()">
            <i class="uil uil-signout text-lg text-dark-gray" aria-hidden="true"></i>
            Log Out
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isSiteOffline" class="lg:hidden">
    <button
      *ngIf="!openSideMenu"
      type="button"
      class="bg-transparent border-0 cursor-pointer p-0"
      aria-label="Open navigation menu"
      (click)="click()">
      <i class="text-4xl uil uil-bars" aria-hidden="true"></i>
    </button>
  </div>
</header>

<!-- Login Modal -->
<div
  *ngIf="!isSiteOffline && isLoginVisible"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
  role="presentation"
  (click)="handleCancel()">

  <section
    #loginDialog
    class="relative w-full max-w-lg rounded bg-white p-6 shadow-lg"
    role="dialog"
    aria-modal="true"
    aria-labelledby="login-dialog-title"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown)="onDialogKeydown($event, loginDialog)">

    <button
      #loginCloseButton
      type="button"
      class="absolute right-4 top-4 bg-transparent border-0 cursor-pointer text-2xl leading-none"
      aria-label="Close login dialog"
      (click)="handleCancel()">
      ×
    </button>

    <h2 id="login-dialog-title" class="text-xl font-semibold mb-4">
      Log In
    </h2>

    <form
      [formGroup]="loginForm"
      class="grid gap-4"
      (ngSubmit)="submit()">

      <prism-input
        [control]="emailAddress"
        label="Email Address"
        placeHolder="Email address"
        [required]="true"
        [inputType]="InputType.Email">
      </prism-input>

      <prism-input
        [control]="password"
        label="Password"
        placeHolder="Password"
        [required]="true"
        [inputType]="InputType.Password">
      </prism-input>

      <hr class="-mx-6" />

      <div class="flex items-center">
        <prism-btn [disabled]="!loginForm.valid">
          Log in
        </prism-btn>

        <p class="ml-4">
          <button
            type="button"
            class="bg-transparent border-0 cursor-pointer p-0 text-dark-purple underline"
            (click)="toggleModal(HeaderModalType.ForgotPw)">
            Forgot password?
          </button>
        </p>
      </div>
    </form>
  </section>
</div>

<!-- Forgot Password Modal -->
<div
  *ngIf="!isSiteOffline && isForgotPwVisible"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
  role="presentation"
  (click)="handleCancel()">

  <section
    #forgotPasswordDialog
    class="relative w-full max-w-lg rounded bg-white p-6 shadow-lg"
    role="dialog"
    aria-modal="true"
    aria-labelledby="forgot-password-dialog-title"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown)="onDialogKeydown($event, forgotPasswordDialog)">

    <button
      #forgotPasswordCloseButton
      type="button"
      class="absolute right-4 top-4 bg-transparent border-0 cursor-pointer text-2xl leading-none"
      aria-label="Close forgot password dialog"
      (click)="handleCancel()">
      ×
    </button>

    <h2 id="forgot-password-dialog-title" class="text-xl font-semibold mb-4">
      Forgot Password
    </h2>

    <p class="mb-4">
      Enter your email address to reset your password.
    </p>

    <form [formGroup]="forgotPwForm" class="grid gap-4">
      <prism-input
        [control]="forgotPwEmailAddress"
        placeHolder="Email address"
        [inputType]="InputType.Email">
      </prism-input>
    </form>

    <div class="flex items-center mt-4">
      <prism-btn
        [disabled]="!forgotPwForm.valid || isProcessing"
        (click)="submitForgotPw()">
        Forgot Password
      </prism-btn>
    </div>
  </section>
</div>

<!-- Forgot Password Success Modal -->
<div
  *ngIf="!isSiteOffline && successModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
  role="presentation"
  (click)="handleCancel()">

  <section
    #successDialog
    class="relative w-full max-w-lg rounded bg-white p-6 shadow-lg"
    role="dialog"
    aria-modal="true"
    aria-labelledby="forgot-password-success-dialog-title"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown)="onDialogKeydown($event, successDialog)">

    <button
      #successCloseButton
      type="button"
      class="absolute right-4 top-4 bg-transparent border-0 cursor-pointer text-2xl leading-none"
      aria-label="Close forgot password confirmation dialog"
      (click)="handleCancel()">
      ×
    </button>

    <h2 id="forgot-password-success-dialog-title" class="text-xl font-semibold mb-4">
      Forgot Password
    </h2>

    <p>
      Please check your inbox shortly for an email to reset your password.
      If you do not receive an email in your inbox after approximately 10-15 minutes,
      check your spam/junk mail folder. Thank you.
    </p>
  </section>
</div>

<!-- Maintenance Mode Modal -->
<div
  *ngIf="maintenanceModeModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
  role="presentation"
  (click)="handleCancel()">

  <section
    #maintenanceDialog
    class="relative w-full max-w-lg rounded bg-white p-6 shadow-lg"
    role="dialog"
    aria-modal="true"
    aria-labelledby="maintenance-dialog-title"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown)="onDialogKeydown($event, maintenanceDialog)">

    <h2 id="maintenance-dialog-title" class="text-xl font-semibold mb-4">
      Maintenance Mode
    </h2>

    <p>{{ maintenanceMessage }}</p>

    <div class="flex justify-end mt-4">
      <prism-btn (click)="handleCancel()">OK</prism-btn>
    </div>
  </section>
</div>